<template>
  <div class="radio-container">
    <label v-for="option in options" :key="option.value" class="radio-label">
      <input type="radio" v-model="model" :value="option.value" :checked="model === option.value" />
      <p>{{ option.label }}</p>
    </label>
  </div>
</template>

<script setup lang="ts">
type Option = {
  label: string;
  value: string;
};

const props = defineProps<{
  options: Option[];
}>();

const model = defineModel('model');
</script>

<style scoped lang="scss">
.radio-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.radio-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  white-space: nowrap;
}
</style>
